import { VerticalComponentMapper } from '../../../../common/constants';
import { Vertical } from '../../../../common/enums';
import { IVerticalComponent } from '../../interfaces';

export const VerticalComponents: IVerticalComponent = {
  [Vertical.CarInsurance]: VerticalComponentMapper[Vertical.CarInsurance],
  [Vertical.PersonalAccidentInsurance]:
    VerticalComponentMapper[Vertical.PersonalAccidentInsurance],
  [Vertical.MotorcycleInsurance]:
    VerticalComponentMapper[Vertical.MotorcycleInsurance],
  [Vertical.TravelInsurance]: VerticalComponentMapper[Vertical.TravelInsurance],
  [Vertical.CriticalIllnessInsurance]:
    VerticalComponentMapper[Vertical.CriticalIllnessInsurance],
  [Vertical.HealthInsurance]: VerticalComponentMapper[Vertical.HealthInsurance],
  [Vertical.PropertyInsurance]:
    VerticalComponentMapper[Vertical.PropertyInsurance],
  [Vertical.ECancerLifeInsurance]:
    VerticalComponentMapper[Vertical.ECancerLifeInsurance],
};
